import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentMain = styled.div``;

export const ContentLower = styled.div`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.COLOR_GRAY_DARKEST};
`;
